"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../lib/utils");

var _poweredByDruva = _interopRequireDefault(require("../poweredByDruva/poweredByDruva"));

require("./footerLinks.css");

var FooterLinks = function FooterLinks(_ref) {
  var inSidebar = _ref.inSidebar,
      links = _ref.links;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _utils.gatherClasses)(null, "oui-global-footer-links", inSidebar && "oui-in-sidebar")
  }, /*#__PURE__*/_react["default"].createElement(_poweredByDruva["default"], {
    white: inSidebar
  }), (0, _map["default"])(links).call(links, function (link, index) {
    var _context, _context2;

    return (0, _utils.isFunction)(link.renderComponent) ? link.renderComponent(link, (0, _concat["default"])(_context = "global-footer-link-".concat(index, "-")).call(_context, link.label)) : /*#__PURE__*/_react["default"].createElement("a", {
      href: link.href,
      target: link.target,
      key: (0, _concat["default"])(_context2 = "global-footer-link-".concat(index, "-")).call(_context2, link.label)
    }, link.label);
  }));
};

FooterLinks.propTypes = {
  inSidebar: _propTypes["default"].bool,
  links: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    target: _propTypes["default"].oneOf(["_blank", "_self", "_parent", "_top"]),
    label: _propTypes["default"].string.isRequired,
    href: _propTypes["default"].string,
    renderComponent: _propTypes["default"].func
  }))
};
FooterLinks.defaultProps = {
  inSidebar: false,
  links: []
};
FooterLinks.displayName = "OrionFooterLinks";
var _default = FooterLinks;
exports["default"] = _default;